export default "__VITE_ASSET__blgqmPCQ__"